// import { useWeb3React } from "@web3-react/core";
import { useEffect, useMemo, useState } from "react";
import Web3 from "web3";
import Environment from "../utils/Environment";
import useWeb3 from "./useWeb3";

const useCurrentBlockNumber = () => {
  // const { provider } = useWeb3React();
  const [blockNumber, setBlockNumber] = useState(null);

  const web3 = useMemo(
    () =>
      new Web3("https://arb-mainnet.g.alchemy.com/v2/m1ZDZF0NDLbqkK-we12g0"),
    []
  );
  // const web3 = useWeb3();

  useEffect(() => {
    if (!web3) return;

    const getBlockNumber = async () => {
      web3.eth
        .getBlockNumber()
        .then((blockNumber) => {
          setBlockNumber(blockNumber);
        })
        .catch(console.error);
    };

    getBlockNumber();

    const interval = setInterval(getBlockNumber, 5000); // refresh every 5 seconds
    return () => clearInterval(interval);
  }, [web3]);

  return blockNumber;
};

export default useCurrentBlockNumber;
